import React from 'react'
import { Menu } from '@styled-icons/material'

// Styles
import { ProfileDropdown, ProfileMenuWrapper, ProfilePicture, ProfileWrapper } from './styles'

// utils
import { getLocalStorageValues } from 'utils/localStorageManager'

const ProfileMenu = ({ toggleMenuModal }) => {
  const user = getLocalStorageValues()

  return (
    <ProfileMenuWrapper>
      <ProfileDropdown aria-label="Profile Dropdown" onClick={toggleMenuModal}>
        <Menu height="33" />
        <ProfileWrapper>
          <ProfilePicture user={user} />
        </ProfileWrapper>
      </ProfileDropdown>
    </ProfileMenuWrapper>
  )
}

export default ProfileMenu
